import { Component } from '@angular/core'

@Component({
  selector: 'flowaccount-google-workspace-3-step',
  templateUrl: './google-workspace-3-step.component.html',
  styleUrl: './google-workspace-3-step.component.scss',
})
export class GoogleWorkspace3StepComponent {}
